import React, { useEffect, useRef, useState } from 'react';

function AdminPopover({ user, setPage, onLogout, isMobile = false }) {
  const [open, setOpen] = useState(false);
  const ref = React.useRef(null);
  useEffect(() => {
    const h = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);
  const initials = (user.name || 'Admin').split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button onClick={() => setOpen(o => !o)}
        className={isMobile ? 'app-admin-trigger app-admin-trigger-mobile' : 'app-admin-trigger'}
        style={{ display: 'flex', alignItems: 'center', gap: isMobile ? 0 : 10, background: 'transparent', border: 'none', cursor: 'pointer', padding: isMobile ? 0 : '4px 6px', borderRadius: 10, transition: 'background 150ms' }}
        onMouseEnter={e => e.currentTarget.style.background = '#f1f5f9'}
        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
        <div style={{ width: 34, height: 34, borderRadius: '50%', background: 'linear-gradient(135deg,#1960a3,#6366f1)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 13, color: '#fff', boxShadow: '0 2px 8px rgba(25,96,163,0.25)', flexShrink: 0, overflow: 'hidden' }}>
          {user.pic ? <img src={user.pic} alt={user.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : initials}
        </div>
        <div className="app-admin-meta" style={{ textAlign: 'left', display: isMobile ? 'none' : 'block' }}>
          <p style={{ fontSize: 12, fontWeight: 700, color: '#1e293b', margin: 0, lineHeight: 1.3 }}>{user.name || 'Admin'}</p>
          <p style={{ fontSize: 10, color: '#94a3b8', margin: 0 }}>{user.role || 'Administrator'}</p>
        </div>
        <span className="material-symbols-outlined app-admin-chevron" style={{ fontSize: 16, color: '#94a3b8', marginLeft: 2, transition: 'transform 200ms', transform: open ? 'rotate(180deg)' : 'rotate(0deg)', display: isMobile ? 'none' : 'inline-flex' }}>expand_more</span>
      </button>

      {open && (
        <div style={{ position: 'absolute', top: 'calc(100% + 10px)', right: 0, width: 260, background: '#fff', borderRadius: 16, boxShadow: '0 8px 32px rgba(0,32,69,0.14)', border: '1px solid #e8edf5', zIndex: 999, overflow: 'hidden', animation: 'pop-in 150ms ease' }}>
          <style>{`@keyframes pop-in{from{opacity:0;transform:translateY(-6px) scale(0.97)}to{opacity:1;transform:none}}`}</style>
          {/* Profile header */}
          <div style={{ padding: '20px 20px 16px', background: 'linear-gradient(135deg,#eef4ff,#f5f0ff)', borderBottom: '1px solid #e8edf5' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
              <div style={{ width: 48, height: 48, borderRadius: '50%', background: 'linear-gradient(135deg,#1960a3,#6366f1)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 18, color: '#fff', boxShadow: '0 4px 12px rgba(25,96,163,0.3)', flexShrink: 0, overflow: 'hidden' }}>
                {user.pic ? <img src={user.pic} alt={user.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : initials}
              </div>
              <div>
                <div style={{ fontSize: 15, fontWeight: 800, color: '#1e293b', fontFamily: 'Manrope,sans-serif' }}>{user.name || 'Admin'}</div>
                <div style={{ fontSize: 11, color: '#64748b', marginTop: 2 }}>@{user.username || 'admin'}</div>
                <span style={{ display: 'inline-block', marginTop: 5, fontSize: 10, fontWeight: 700, color: '#1960a3', background: '#dbeafe', padding: '2px 10px', borderRadius: 20, letterSpacing: '0.04em' }}>{user.role || 'Administrator'}</span>
              </div>
            </div>
          </div>
          {/* Info rows */}
          <div style={{ padding: '12px 20px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0', borderBottom: '1px solid #f1f5f9' }}>
              <span className="material-symbols-outlined" style={{ fontSize: 16, color: '#94a3b8' }}>badge</span>
              <div>
                <div style={{ fontSize: 10, color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Username</div>
                <div style={{ fontSize: 13, color: '#1e293b', fontWeight: 600 }}>@{user.username || 'admin'}</div>
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0' }}>
              <span className="material-symbols-outlined" style={{ fontSize: 16, color: '#94a3b8' }}>manage_accounts</span>
              <div>
                <div style={{ fontSize: 10, color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em' }}>Role</div>
                <div style={{ fontSize: 13, color: '#1e293b', fontWeight: 600 }}>{user.role || 'Administrator'}</div>
              </div>
            </div>
          </div>
          {/* Action */}
          <div style={{ padding: '0 12px 12px' }}>
            <button onClick={() => { setOpen(false); onLogout(); }}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, width: '100%', padding: '10px', borderRadius: 10, border: 'none', background: 'linear-gradient(135deg,#ef4444,#dc2626)', color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer', boxShadow: '0 4px 12px rgba(239,68,68,0.25)', transition: 'opacity 150ms' }}
              onMouseEnter={e => e.currentTarget.style.opacity = '0.9'}
              onMouseLeave={e => e.currentTarget.style.opacity = '1'}>
              <span className="material-symbols-outlined" style={{ fontSize: 16 }}>logout</span>
              Sign Out
            </button>
          </div>
        </div>
      )}
    </div>
  );
}


export default AdminPopover;
